// extracted by mini-css-extract-plugin
export var appt = "styles-module--appt--bf7a4";
export var confirm = "styles-module--confirm--1ec8e";
export var error = "styles-module--error--d5929";
export var form = "styles-module--form--1b4e1";
export var message = "styles-module--message--a1e81";